import { isIterable } from '../iterables';

export type MaybeArray<T> = undefined | null | T | T[];

export function toArray<T>(value: null | undefined | T | Iterable<T>): T[] {
    if (!value) return [];
    if (isIterable(value)) return [...value];
    return [value];
}

export default function normalizeArray<T>(item: MaybeArray<T>): T[] {
    if (Array.isArray(item)) return item;
    if (!item) return [];
    return [item];
}
